import { useState } from "react";
import CreatableSelect from "react-select/creatable";
const MyCreatableInput = ({
  register,
  setValue,
  getValues,
  trigger,
  name,
  setError,
  errors,
  email,
  mobile,
  placeholder,
}) => {
  const [inputValue, setInputValue] = useState("");

  const components = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

  const handleKeyDown = (event) => {
    const input = inputValue.trim();
    const key = event.key;
    if (!input) return;
    if (key === "Enter" || key === "Tab") {
      event.preventDefault();

      if (email) {
        const currentEmails = getValues(name) || [];
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(input)) {
          setError(name, {
            type: "manual",
            message: "Invalid email format",
          });
          return;
        }
        const isDuplicate = currentEmails.some((item) => item?.value?.toLowerCase() === input.toLowerCase());
        if (isDuplicate) {
          setError(name, {
            type: "manual",
            message: "Email already exists",
          });
          return;
        }
        const newOption = createOption(input);
        setValue(name, [...currentEmails, newOption]);
        setInputValue("");
        setError(name, "");
      } else if (mobile) {
        const currentMobiles = getValues(name) || [];
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(input)) {
          setError(name, {
            type: "manual",
            message: "Invalid mobile format",
          });
          return;
        }
        const isDuplicate = currentMobiles.some((item) => item?.value?.toLowerCase() === input.toLowerCase());
        if (isDuplicate) {
          setError(name, {
            type: "manual",
            message: "Mobile already exists",
          });
          return;
        }
        const newOption = createOption(input);
        setValue(name, [...currentMobiles, newOption]);
        setInputValue("");
        setError(name, "");
      } else {
        if (!inputValue) return;
        const prev = getValues(name) || [];
        const newOption = createOption(inputValue);
        setValue(name, [...prev, newOption]);
        setInputValue("");
        event.preventDefault();
      }
    }
  };

  const onChange = (newValue) => {
    setValue(name, newValue || []);
    trigger(name);
  };
  const values = getValues(name);
  console.log("ihih",errors)
  return (
    <>
      <CreatableSelect
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={onChange}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || "Type something and press enter..."}
        value={values}
        name={name}
      />
      <input type="hidden" {...register(name)} />
      {errors[name] && (
        <span
          className="invalid"
          style={{
            color: "#e85347",
            fontSize: "11px",
            fontStyle: "italic",
          }}
        >
          {errors[name]?.message}
        </span>
      )}
    </>
  );
};

export default MyCreatableInput;
